export default class BasicSlotElement extends HTMLElement {
  constructor() {
    super();

    const shadow = this.attachShadow({ mode: "open" });

    if (shadow) shadow.innerHTML = `<slot></slot>`;
  }
}
